import { useSyncExternalStore } from "react";
import {
  getAnalyticsConsent,
  setAnalyticsConsent,
  subscribeToConsent,
  type AnalyticsConsent,
} from "@/lib/consent";

function getServerSnapshot(): AnalyticsConsent {
  return "unset";
}

/**
 * Current analytics consent (`granted` / `denied` / `unset`) plus a setter.
 * Re-renders on changes from this tab and from other tabs. Starting and
 * stopping the SDK is handled by `lib/otel-consent.ts`, which subscribes to
 * the same store.
 */
export function useAnalyticsConsent(): {
  consent: AnalyticsConsent;
  setConsent: (analytics: boolean) => void;
} {
  const consent = useSyncExternalStore(
    subscribeToConsent,
    getAnalyticsConsent,
    getServerSnapshot,
  );
  return { consent, setConsent: setAnalyticsConsent };
}
